export const galleryAlbums = [
  {
    id: 15,
    title: "AGM",
    folder: "agm",
    category: "Community",
    description:
      "Annual General Meeting at Rajasthan Association (RAJAT Hall), Sindoor Plaza — reports, direction, and fellowship with the SMYM community",
    date: "2026-05-03",
    photos: [
      "/Gallery/agm/agm_1.png",
      "/Gallery/agm/agm_2.png",
      "/Gallery/agm/agm_3.png",
    ],
    // Card-sized WebP. The lightbox still opens the original PNG.
    coverWebp: "/Gallery/agm/agm_1.webp",
  },
  {
    id: 14,
    title: "Temple Run 2.0",
    folder: "TempleRun2",
    category: "Heritage",
    description:
      "Arunachala Pradakshina — Melmaruvathur, Nomad Café bhajan jamming, Girivalam pradakshina & Arunachaleshwar darshan",
    date: "2026-04-04",
    photos: [
      "/Gallery/TempleRun2/TR1.png",
      "/Gallery/TempleRun2/TR2.png",
      "/Gallery/TempleRun2/TR3.png",
      "/Gallery/TempleRun2/TR4.png",
      "/Gallery/TempleRun2/TR5.png",
      "/Gallery/TempleRun2/TR6.png",
    ],
  },
  {
    id: 13,
    title: "Quietly Powerful",
    folder: "Quietly-Powerful",
    category: "Celebration",
    description:
      "International Women's Day at Shenoy Nagar — resin art workshop, felicitation & LifeCell awareness session",
    date: "2026-03-08",
    photos: [
      "/Gallery/Quietly-Powerful/1.jpeg",
      "/Gallery/Quietly-Powerful/2.jpeg",
      "/Gallery/Quietly-Powerful/3.jpeg",
      "/Gallery/Quietly-Powerful/4.jpeg",
      "/Gallery/Quietly-Powerful/5.jpeg",
      "/Gallery/Quietly-Powerful/6.jpeg",
    ],
  },
  {
    id: 1,
    title: "Turtle Trail",
    folder: "TurtleTrail",
    category: "Adventure",
    description:
      "Guided night walk along Chennai's shoreline with Sea Turtle Conservation Network",
    date: "2026-02-21",
    photos: [
      "/Gallery/TurtleTrail/Turtle Trail 1.jpeg",
      "/Gallery/TurtleTrail/Turtle Trail 2.jpeg",
      "/Gallery/TurtleTrail/Turtle Trail 3.jpeg",
    ],
  },
  {
    id: 2,
    title: "Neel & Neer",
    folder: "Neel&Neer",
    category: "Wellness",
    description:
      "Mahashivratri morning experience - jog, inner circle discussion & ice bath",
    date: "2026-02-15",
    photos: [
      "/Gallery/Neel&Neer/Neel & Neer 1.jpeg",
      "/Gallery/Neel&Neer/Neel & Neer 2.jpeg",
      "/Gallery/Neel&Neer/Neel & Neer 3.jpeg",
      "/Gallery/Neel&Neer/Neel & Neer 4.jpeg",
    ],
  },
  {
    id: 3,
    title: "Temple Run",
    folder: "TempleRun",
    category: "Heritage",
    description:
      "Heritage walk visiting 3 temples - Sri Kapaleeswarar, Sri Parthasarathy & RK Math",
    date: "2026-01-25",
    photos: [
      "/Gallery/TempleRun/Temple Run 1.jpeg",
      "/Gallery/TempleRun/Temple Run 2.jpeg",
      "/Gallery/TempleRun/Temple Run 3.jpeg",
    ],
  },
  {
    id: 4,
    title: "Annakut Mahotsav",
    folder: "Annkut",
    category: "Festival",
    description:
      "Shree Maheshwari Annakut Mahotsav for the entire Vaishnav Samaj in Chennai",
    date: "2025-10-26",
    photos: [
      "/Gallery/Annkut/Annkut 1.jpg",
      "/Gallery/Annkut/Annkut 2.jpg",
      "/Gallery/Annkut/Annkut 3.jpg",
      "/Gallery/Annkut/Annkut 4.jpg",
    ],
  },
  {
    id: 5,
    title: "Utkarsh",
    folder: "Utkarsh",
    category: "Cultural",
    description:
      "SMYM's Diwali Milan event - felicitation & NextGen Superstar performances",
    date: "2025-10-05",
    photos: [
      "/Gallery/Utkarsh/Utkarsh 1.jpg",
      "/Gallery/Utkarsh/Utkarsh 2.jpg",
      "/Gallery/Utkarsh/Utkarsh 3.jpg",
      "/Gallery/Utkarsh/Utkarsh 4.jpg",
      "/Gallery/Utkarsh/Utkarsh 5.jpg",
      "/Gallery/Utkarsh/Utkarsh 6.jpg",
    ],
  },
  {
    id: 6,
    title: "Mission ISRO",
    folder: "Mission-ISRO",
    category: "Educational",
    description: "Visit to NRSC Hyderabad - Space as Career opportunity",
    date: "2025-09-25",
    photos: [
      "/Gallery/Mission-ISRO/Mission ISRO 1.jpg",
      "/Gallery/Mission-ISRO/Mission ISRO 2.jpg",
      "/Gallery/Mission-ISRO/Mission ISRO 3.jpg",
    ],
  },
  {
    id: 7,
    title: "Evolve Fest",
    folder: "Evolve Fest",
    category: "Spiritual",
    description: "3 day Spiritual Retreat at Shri Bramrishi Ashram, Tirupati",
    date: "2025-09-18",
    photos: [
      "/Gallery/Evolve Fest/Evolve Fest 1.jpg",
      "/Gallery/Evolve Fest/Evolve Fest 2.jpg",
      "/Gallery/Evolve Fest/Evolve Fest 3.jpg",
    ],
  },
  {
    id: 8,
    title: "Cyclothon",
    folder: "Cyclothon1",
    category: "Sports",
    description: "Cycling event in association with Rajat – 10kms, 25kms, 50kms",
    date: "2025-09-14",
    photos: [
      "/Gallery/Cyclothon1/Cyclothon 1.jpg",
      "/Gallery/Cyclothon1/Cyclothon 2.jpg",
      "/Gallery/Cyclothon1/Cyclothon 3.jpg",
    ],
  },
  {
    id: 9,
    title: "Hasyam",
    folder: "Hasyam",
    category: "Cultural",
    description: "Humor poetry symposium at Chinmaya Heritage Center, Chetpet",
    date: "2025-08-31",
    photos: ["/Gallery/Hasyam/Hasyam Pic.jpg"],
  },
  {
    id: 10,
    title: "NextGen Superstar",
    folder: "NextGen",
    category: "Cultural",
    description: "All India Culturals at Hyderabad - 14 finalists, 7 podium finishes",
    date: "2025-08-22",
    photos: [
      "/Gallery/NextGen/Nextgen Superstar 1.jpg",
      "/Gallery/NextGen/Nextgen Superstar 2.jpg",
      "/Gallery/NextGen/Nextgen superstar 3.jpg",
      "/Gallery/NextGen/Nextgen Superstar 4.jpg",
      "/Gallery/NextGen/Nextgen Superstar 5.jpg",
      "/Gallery/NextGen/Nextgen Superstar 6.jpg",
      "/Gallery/NextGen/Nextgen Superstar 7.jpg",
      "/Gallery/NextGen/Nextgen Superstar 8.jpg",
    ],
  },
  {
    id: 11,
    title: "War 2 Movie",
    folder: "War2",
    category: "Entertainment",
    description: "Movie screening for SMYM members on Independence Day",
    date: "2025-08-15",
    photos: ["/Gallery/War2/War 2 Pics.jpg"],
  },
  {
    id: 12,
    title: "Tayyari Jeet Ki",
    folder: "Tayyari-jeet-ki",
    category: "Cultural",
    description: "NextGen Superstar Prelims at Agarwal Vidyalaya, Chennai",
    date: "2025-06-29",
    photos: [
      "/Gallery/Tayyari-jeet-ki/Tayyari Jeet Ki 1.JPG",
      "/Gallery/Tayyari-jeet-ki/Tayyari Jeet Ki 2.JPG",
      "/Gallery/Tayyari-jeet-ki/Tayyari Jeet ki 3.JPG",
      "/Gallery/Tayyari-jeet-ki/Tayyari Jeet Ki 4.JPG",
    ],
  },
];
export const galleryImages = galleryAlbums.map((album) => ({
  id: album.id,
  title: album.title,
  category: album.category,
}));
